import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import HomePage from '../views/home/HomePage.vue'
import IntroPage from '../views/cms/IntroPage.vue'
import TopicPage from '../views/cms/TopicPage.vue'
import AnnouncementsPage from '../views/news/AnnouncementsPage.vue'
import NewsPublishPage from '../views/news/NewsPublishPage.vue'
import ContentDetailPage from '../views/news/ContentDetailPage.vue'
import HomePortalListPage from '../views/portal/HomePortalListPage.vue'
import PartyPage from '../views/party/PartyPage.vue'
import ServicesPage from '../views/services/ServicesPage.vue'
import PersonalCenterPage from '../views/personal/PersonalCenterPage.vue'
import StructurePage from '../views/structure/StructurePage.vue'
import BranchSitePage from '../views/structure/BranchSitePage.vue'
import DownloadsPage from '../views/downloads/DownloadsPage.vue'
import ConferenceDetailPage from '../views/conference/ConferenceDetailPage.vue'
import CstCloudResultPage from '../views/auth/CstCloudResultPage.vue'
import CstCloudOnboardingPage from '../views/auth/CstCloudOnboardingPage.vue'
import CstCloudBindExistingPage from '../views/auth/CstCloudBindExistingPage.vue'
import NotFoundPage from '../views/errors/NotFoundPage.vue'
import { BRANCH_SITE_SECTIONS } from '../data/branchSite'

Vue.use(Router)

const partyRoutes = [
  { path: 'announcements', page: 'announcements' },
  { path: 'organizations', page: 'organizations' },
  { path: 'organizations/work-office', redirect: '/organizations', cat: '党群工作处' },
  { path: 'organizations/party-branch', redirect: '/organizations', cat: '党支部委员会' },
  { path: 'organizations/union', redirect: '/organizations', cat: '工会' },
  { path: 'organizations/youth-league', redirect: '/organizations', cat: '共青团委员会' },
  { path: 'committees', page: 'committees' },
  { path: 'work', page: 'work' },
  { path: 'activities', page: 'activities' },
  { path: 'activities/election', redirect: '/activities', cat: '换届选举' },
  { path: 'activities/three-meetings', redirect: '/activities', cat: '三会一课' },
  { path: 'activities/theme-day', redirect: '/activities', cat: '主题党日' },
  { path: 'activities/org-life-meeting', redirect: '/activities', cat: '组织生活会' },
  { path: 'activities/center-study', redirect: '/activities', cat: '中心组学习' },
  { path: 'activities/democratic-life', redirect: '/activities', cat: '民主生活会' },
  { path: 'activities/member-review', redirect: '/activities', cat: '民主评议党员' },
  { path: 'activities/events', redirect: '/activities', cat: '各类党组织活动' },
  { path: 'team-building', page: 'team-building' },
  { path: 'team-building/overview', redirect: '/team-building', cat: '党员队伍概况' },
  { path: 'team-building/development', redirect: '/team-building', cat: '发展党员' },
  { path: 'team-building/education', redirect: '/team-building', cat: '党员教育' },
  { path: 'team-building/management', redirect: '/team-building', cat: '党员管理' },
  { path: 'team-building/service', redirect: '/team-building', cat: '党员服务' },
  { path: 'team-building/rewards', redirect: '/team-building', cat: '党员奖惩' },
  { path: 'team-building/dues', redirect: '/team-building', cat: '党费管理' },
  { path: 'theory-study', page: 'theory-study' },
  { path: 'dynamics', page: 'dynamics' },
  { path: 'special-topics', page: 'special-topics' },
  { path: 'special-topics/:entryId', page: 'special-topics' },
  { path: 'exemplars', page: 'exemplars' },
  { path: 'reporting', page: 'reporting' },
  { path: 'downloads', page: 'party-downloads' }
]

const topicRoutes = [
  { path: 'history', page: 'history' },
  { path: 'gallery', page: 'gallery' },
  { path: 'international', page: 'international' },
  { path: 'regulations', page: 'regulations' }
]

const branchRoutes = BRANCH_SITE_SECTIONS.reduce((routes, section) => {
  routes.push(
    {
      path: `structure/branch/:branchId/${section.id}`,
      component: BranchSitePage,
      meta: { page: 'branch-site', branchSection: section.id, title: section.title }
    },
    {
      path: `structure/branch/:branchId/${section.id}/content/:id`,
      component: ContentDetailPage,
      meta: { page: 'content-detail', contentScope: 'branch', branchSection: section.id, title: section.title }
    }
  )
  return routes
}, [])

const publicPath = process.env.VUE_APP_PUBLIC_PATH || '/'
const base = publicPath === './' ? '/' : publicPath

export default new Router({
  mode: 'history',
  base,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        { path: '', component: HomePage, meta: { page: 'home' } },
        { path: 'intro', component: IntroPage, meta: { page: 'intro' } },
        { path: 'structure', component: StructurePage, meta: { page: 'structure' } },
        {
          path: 'structure/branch/:branchId',
          redirect: to => `/structure/branch/${to.params.branchId}/home`
        },
        ...branchRoutes,
        { path: 'branches', component: StructurePage, meta: { page: 'branches' } },
        ...topicRoutes.map(route => ({
          path: route.path,
          component: TopicPage,
          meta: { page: route.page }
        })),
        { path: 'news', redirect: '/news-publish' },
        { path: 'society-announcements', component: AnnouncementsPage, meta: { page: 'society-announcements' } },
        { path: 'news-publish', component: NewsPublishPage, meta: { page: 'news-publish' } },
        {
          path: 'publications',
          component: HomePortalListPage,
          meta: { page: 'publications', portalColumn: 'publications' }
        },
        {
          path: 'society-dynamics',
          redirect: { path: '/news-publish', query: { board: 'society_dynamics' } }
        },
        {
          path: 'work-progress',
          redirect: { path: '/news-publish', query: { board: 'work_progress' } }
        },
        { path: 'public-downloads', component: DownloadsPage, meta: { page: 'public-downloads' } },
        { path: 'downloads-center', component: DownloadsPage, meta: { page: 'downloads-center' } },
        { path: 'services', component: ServicesPage, meta: { page: 'services' } },
        { path: 'personal-center', component: PersonalCenterPage, meta: { page: 'personal-center' } },
        { path: 'party', component: PartyPage, meta: { page: 'party' } },
        ...partyRoutes.map(route => (route.redirect
          ? {
            path: route.path,
            redirect: { path: route.redirect, query: route.cat ? { cat: route.cat } : {} }
          }
          : {
            path: route.path,
            component: PartyPage,
            meta: { page: route.page }
          })),
        { path: 'content/:id', component: ContentDetailPage, meta: { page: 'content-detail' } },
        { path: 'conference/:id', component: ConferenceDetailPage, meta: { page: 'conference-detail' } },
        { path: 'auth/cstcloud/result', component: CstCloudResultPage, meta: { page: 'cstcloud-result' } },
        { path: 'auth/cstcloud/onboarding', component: CstCloudOnboardingPage, meta: { page: 'cstcloud-onboarding' } },
        { path: 'auth/cstcloud/bind-existing', component: CstCloudBindExistingPage, meta: { page: 'cstcloud-bind-existing' } },
        { path: '404', name: 'not-found', component: NotFoundPage, meta: { page: 'not-found' } },
        { path: '*', redirect: '/404' }
      ]
    }
  ]
})
